import { useTranslation } from "react-i18next";
import { StyledTenantsCard } from "./TenantsCard.styled";
import manager from '../../../images/newDesign/manager.svg';
import hammer from '../../../images/newDesign/hammer.svg';
import star from '../../../images/newDesign/star.svg';

export function TenantsCard({ tenant, isPrimary }) {
    const { t } = useTranslation();

    const { tenant: tenantInfo, details } = tenant;

    const tenantType = tenantInfo?.tenantType ? t(`reports.tenantType.${tenantInfo.tenantType}`) : '';

    return (
        <StyledTenantsCard>
            <div className="icons">
                {isPrimary && <img src={star} />}
                {tenantInfo.buildingManager && <img src={manager} />}
                {tenantInfo.legalIssues && <img src={hammer} />}
            </div>
            <div className="tenant-type">{tenantType}</div>
            <div>{details?.name}</div>
            <div>{details?.phone}</div>
            <div>{details?.email}</div>
        </StyledTenantsCard>
    )
}